import { TICKET_STATUSES, type TicketStatus } from '@/db/schema'

export const INBOX_ALL_UNRESPONDED_STATUS = 'unresponded'
export const INBOX_ALL_STATUSES = 'all'

export type InboxStatusFilter =
  | typeof INBOX_ALL_UNRESPONDED_STATUS
  | typeof INBOX_ALL_STATUSES
  | TicketStatus

export function isInboxUnrespondedLastInteraction(lastMessageRole: string | null | undefined): boolean {
  return lastMessageRole !== 'expert'
}

export function normalizeInboxStatusFilter(value: string | undefined): InboxStatusFilter {
  if (!value) return INBOX_ALL_UNRESPONDED_STATUS
  if (value === INBOX_ALL_STATUSES) return INBOX_ALL_STATUSES
  if ((TICKET_STATUSES as readonly string[]).includes(value)) return value as TicketStatus
  return INBOX_ALL_UNRESPONDED_STATUS
}
